"use client";

import { Core } from "@faire/design-tokens";
import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated use `@faire/slate/icons/Book` instead (legacy Slate foundation icons cannot be deleted from code even if unused in frontend because they may be referenced to in Builder.io page data) */
export const Book = createSVGIcon(
  <g clipPath="url(#clip0_4635_536)" stroke="currentColor">
    <path
      d="M12 22.91a15.54 15.54 0 0 0-9.417-4.951A1.68 1.68 0 0 1 1.09 16.28V2.768a1.68 1.68 0 0 1 1.914-1.662A15.6 15.6 0 0 1 12 6.007zM12 22.91a15.54 15.54 0 0 1 9.417-4.951 1.68 1.68 0 0 0 1.494-1.679V2.768a1.68 1.68 0 0 0-1.914-1.662A15.6 15.6 0 0 0 12 6.007z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </g>,
  "Book",
  {
    color: Core.icon.default,
    fill: "none",
    viewBox: "0 0 24 24",
    className: legacyIconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
